var AppleLogin = (function () {
    try {

        if (!appleApiAvailable) return;

        return {
            clickAppleLoginButton: clickAppleLoginButton,
        }

        function clickAppleLoginButton() {

            var ClientId = 'web.flow';
            var isElectron = ElectronApi.Comm.isElectron();

            if (Often.isBrowser('ie')) {
                alert(c18n('ui.ie.limit', 'IE 브라우저에서 지원하지 않는 기능입니다. 크롬 및 다른 브라우저에서 다시 시도해주세요.'));
                return;
            }
            const isRenewalSignUp = !!window?.isRenewalSignUp ;
            if (!isRenewalSignUp && Often.isMobile()) {
                MobileApp.goMarketOrApp({USER_ID: _USER_ID});
                return;
            }

            AppleID.auth.init({
                clientId: ClientId,
                scope: 'name email',
                redirectURI: Often.getLocOrigin() + '/appleRedirect.act',
                state: 'DE',
                usePopup: true //or false defaults to false
            });



            AppleID.auth.signIn().then(function (data) {
                var appleIdToken = Often.null2Void(data.authorization.id_token, "");
                if (appleIdToken !== "" && appleIdToken.indexOf(".") > -1) {
                    var appleId = parseJwt(appleIdToken).sub;
                    GoogleTagManager.collect({
                        event: "guest",
                        userId: appleId,
                        guestDate: Time.currentTime(),
                    })

                    const basicProfile = getProfileJson(appleId);
                    if(isRenewalSignUp && Mutil.isAct("newSignup.act")) {
                        const SignUpViewChanger = requireModule('SignUpViewChanger', {on: ['signup', 'index', 'newSignup']})();
                        SignUpViewChanger.loadSocialLoginSuccess(basicProfile);
                        return;
                    }
                    CommonLogin.goLogin(basicProfile);
                } else {
                    console.error("apple error");
                }

                function getProfileJson(appleId) {
                    return {
                        "USER_ID": appleId,
                        "ID_GB": SignCode.TYPE.APPLE,
                        "EMAIL": "",
                        "USER_NM" : "",
                        "OBJ_CNTS_NM": (isElectron ? "desktop" : ""),
                    };
                }
            });
        }

        function parseJwt(token) {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            let returnData;
            try {
                returnData = JSON.parse(jsonPayload)
            } catch(error) {}
            return returnData;
        }
    } catch (e) {
        console.error(e);
    }
})()